import { Fonts } from '../../../config/theme';
import Styled from 'styled-components';
import selectArrow from '../../../assets/images/svg/select-arrow-down-icon.svg';

type SelectDivProps = {
  text: string;
  click: () => void;
  active: boolean;
};

const SelectDiv = ({ text, click, active }: SelectDivProps) => {
  return (
    <SelectDivStyled $active={active} onClick={click}>
      {text}
    </SelectDivStyled>
  );
};
const SelectDivStyled = Styled.div<{ $active: boolean }>`
    background-image: url(${selectArrow});
    background-repeat: no-repeat;
    background-position: right 15px center;
    appearance: none;
    padding: 9px 10px 8px;
    width: 100%;
    height: 39px;
    border: 1px solid #E8E8E8;
    border-radius: 5px;
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    letter-spacing: -0.408px;
    font-family: ${Fonts.secondary};
    color: ${(props) =>
      props.$active
        ? 'var(--dark-color) !important'
        : 'var(--secondary-color) !important'} ;
    cursor: pointer;
`;
export { SelectDiv };
